import C from "./util/net.js";
import ve from "./models/braze-event.js";
import t from "./common/event-logger.js";
import { randomInclusive as U } from "./util/math.js";
import s from "./models/request-result.js";
import {
  logger as r,
  IndexedDBAdapter as A,
  Guid as p,
  EventTypes as i,
} from "../shared-lib/index.js";
import { STORAGE_KEYS as o } from "./managers/storage-manager.js";
import T from "./managers/subscription-manager.js";
import yt from "./Push/utils/push-utils.js";
import D from "./util/request-header-utils.js";
export default class Lt {
  constructor(t, i, s, e, h, o, n, r, u, l) {
    (this.rn = t),
      (this.baseUrl = i),
      (this.oi = s),
      (this.on = e),
      (this.yt = h),
      (this.qt = o),
      (this.u = n),
      (this.yu = r),
      (this.Ko = u),
      (this.$t = l),
      (this.rn = t),
      (this.baseUrl = i),
      (this.ju = 0),
      (this.fE = n.dE() || 0),
      (this.$u = null),
      (this.oi = s),
      (this.on = e),
      (this.yt = h),
      (this.qt = o),
      (this.u = n),
      (this.Ko = u),
      (this.$t = l),
      (this.yu = r),
      (this.Fu = new T()),
      (this.Lu = null),
      (this.Mu = 50),
      (this.Pu = !1);
  }
  xu(t, i) {
    return !t && !i && this.Ko.Gh() >= this.Mu;
  }
  Iu(t) {
    let s = this.oi.Gl();
    if (t.length > 0) {
      const e = this.yt.getUserId();
      for (const h of t) {
        const t = (!h.userId && !e) || h.userId === e;
        h.type === i.ql && t && (s = !0);
      }
    }
    return s;
  }
  Nu(t = !1, i = !1, s = !0, e, h, n, u = !1, l = !1) {
    s && this.Ou();
    const a = this.u.AE(),
      c = this.u.OE();
    let d = !1;
    const m = (t, i, r = -1) => {
        let u = !1;
        const l = new Date().valueOf();
        D.Hs(this.u, D._s.Ka, l),
          -1 !== r && i.push(["X-Braze-Req-Tokens-Remaining", r.toString()]),
          C.Ks({
            url: this.baseUrl + "/data/",
            data: t,
            headers: i,
            L: (s) => {
              null != t.respond_with &&
                t.respond_with.triggers &&
                (this.ju = Math.max(this.ju - 1, 0)),
                this.$t.Qs(t, s, i)
                  ? (this.Ko.Vs(),
                    this.qt.al(s),
                    (null != t.respond_with &&
                      t.respond_with.user_id != this.yt.getUserId()) ||
                      (null != t.device && this.u.I(o.C.Fa, t.device),
                      null != t.sdk_metadata &&
                        (this.u.I(o.C.Jh, t.sdk_metadata),
                        this.u.I(o.C.Qh, this.oi.xi())),
                      this.yu(s),
                      D.Ws(this.u, D._s.Ka, 1),
                      "function" == typeof e && e()))
                  : s.auth_error && (u = !0);
            },
            error: () => {
              null != t.respond_with &&
                t.respond_with.triggers &&
                (this.ju = Math.max(this.ju - 1, 0)),
                this.$t.Zh(t.events, t.attributes),
                "function" == typeof h && h();
            },
            Zs: (t) => {
              if (("function" == typeof n && n(t), s && !d)) {
                if (t && !u) this.zu();
                else {
                  D.ti(this.u, D._s.Ka);
                  let t = this.$u;
                  (null == t || t < 1e3 * this.fE) && (t = 1e3 * this.fE),
                    this.zu(Math.min(3e5, U(1e3 * this.fE, 3 * t)));
                }
                d = !0;
              }
            },
          });
      },
      f = this.Iu(a),
      g = i || f;
    if (this.xu(u, f))
      return void r.info(
        "Declining to flush data due to 50 consecutive authentication failures",
      );
    if (s && !this.$t.La(a, c, t, g))
      return this.zu(), void ("function" == typeof n && n(!0));
    const v = this.$t.Ea(t, g, a, c, l);
    g && this.ju++;
    let p = !1;
    if (v)
      for (const t of v)
        this.$t.Gs(
          t.requestData,
          (i) => m(t.requestData, t.headers, i),
          D._s.Ka,
          h,
        ),
          (p = !0);
    this.Ko.Fh() && s && !p
      ? this.zu()
      : f && (r.info("Invoking new session subscriptions"), this.Fu.Rt());
  }
  Uu() {
    return this.ju > 0;
  }
  zu(t = 1e3 * this.fE) {
    this.Pu ||
      (this.Ou(),
      (this.Lu = window.setTimeout(() => {
        if (document.hidden) {
          const t = "visibilitychange",
            i = () => {
              document.hidden ||
                (document.removeEventListener(t, i, !1), this.Nu());
            };
          document.addEventListener(t, i, !1);
        } else this.Nu();
      }, t)),
      (this.$u = t));
  }
  Ou() {
    null != this.Lu && (clearTimeout(this.Lu), (this.Lu = null));
  }
  initialize() {
    (this.Pu = !1), this.zu();
  }
  destroy() {
    this.Fu.removeAllSubscriptions(),
      this.Ko.yh(),
      this.Ou(),
      (this.Pu = !0),
      this.Nu(void 0, void 0, !1, void 0, void 0, void 0, void 0, !0),
      (this.Lu = null);
  }
  mr(t) {
    return this.Fu.Nt(t);
  }
  openSession() {
    const t = this.oi.xi() !== this.oi.xo();
    t && (this.u.cE(o.iu.Uo), this.u.cE(o.iu.su)),
      this.Nu(void 0, !1, void 0, () => {
        this.u.ii(o.C.wi);
      }),
      this.Mn(),
      t &&
        import("./Push/push-manager-factory.js").then((t) => {
          if (this.Pu) return;
          const i = t.default.m();
          if (
            null != i &&
            (yt.isPushPermissionGranted() || yt.isPushBlocked())
          ) {
            const t = () => {
                i.mn()
                  ? r.info(
                      "Push token maintenance is disabled, not refreshing token for backend.",
                    )
                  : i.subscribe();
              },
              s = (i, s) => {
                s && t();
              },
              e = () => {
                const i = this.u.j(o.C.In);
                (null == i || i) && t();
              },
              h = A.ts.Zt;
            new A(h, r).jr(h.hs.cu, s, e);
          }
        });
  }
  _u() {
    this.u.ii(o.C.vi), this.u.ii(o.C.bs), this.u.ii(o.C.Xr);
  }
  changeUser(t, i, s) {
    const e = this.yt.getUserId();
    if (e !== t) {
      this.oi.yl(),
        this._u(),
        null != e && this.Nu(void 0, !1, void 0, void 0, void 0),
        this.yt.ou(t),
        s ? this.Ko.setSdkAuthenticationSignature(s) : this.Ko.xh();
      for (let t = 0; t < i.length; t++) i[t].changeUser(null == e);
      null != e && this.u.ii(o.C.J),
        this.u.ii(o.C.Fa),
        this.u.ii(o.C.nE),
        this.u.ii(o.C._E),
        this.openSession(),
        r.info('Changed user to "' + t + '".');
    } else {
      let i = "Doing nothing.";
      s &&
        this.Ko.kh() !== s &&
        (this.Ko.setSdkAuthenticationSignature(s),
        (i = "Updated SDK authentication signature")),
        r.info(`Current user is already ${t}. ${i}`);
    }
  }
  requestImmediateDataFlush(t) {
    this.Ou(), this.oi.xo();
    this.Nu(
      void 0,
      void 0,
      void 0,
      void 0,
      () => {
        r.error("Failed to flush data, request will be retried automatically.");
      },
      t,
      !0,
    );
  }
  requestFeedRefresh() {
    this.oi.xo(), this.Nu(!0);
  }
  $r(t, i) {
    this.oi.xo(),
      r.info("Requesting explicit trigger refresh."),
      this.Nu(void 0, !0, void 0, t, i);
  }
  Cn(s, e) {
    const h = i.Eu,
      n = { a: s, l: e },
      u = t.q(h, n);
    return (
      u && (r.info(`Logged alias ${s} with label ${e}`), this.u.I(o.C._E, n)), u
    );
  }
  Fn(i, e, h) {
    if (this.qt.hu(e))
      return (
        r.info(`Custom Attribute "${e}" is blocklisted, ignoring.`), new s()
      );
    const o = { key: e, value: h },
      n = t.q(i, o);
    if (n) {
      const t = "object" == typeof h ? JSON.stringify(h, null, 2) : h;
      r.info(`Logged custom attribute: ${e} with value: ${t}`);
    }
    return n;
  }
  setLastKnownLocation(s, e, h, o, n, u) {
    const l = { latitude: e, longitude: h };
    null != o && (l.altitude = o),
      null != n && (l.ll_accuracy = n),
      null != u && (l.alt_accuracy = u);
    const a = t.q(i.Ju, l, s || void 0);
    return (
      a &&
        r.info(`Set user last known location as ${JSON.stringify(l, null, 2)}`),
      a
    );
  }
  kr(t, s) {
    const e = this.oi.xo();
    return new ve(this.yt.getUserId(), i.Ku, t, e, { cid: s });
  }
  Wu(t, i) {
    return new A(t, i);
  }
  Mn() {
    const t = A.ts.Zt;
    this.Wu(t, r).setItem(t.hs.Ka, 1, {
      baseUrl: this.baseUrl,
      data: { api_key: this.rn, device_id: this.on.ce().id },
      userId: this.yt.getUserId(),
      sdkAuthEnabled: this.Ko.Fh(),
    });
  }
  yr(t) {
    for (const i of t)
      if (i.api_key === this.rn) this.$t.Zh(i.events, i.attributes);
      else {
        const t = A.ts.Zt;
        new A(t, r).setItem(t.hs.wr, p.W(), i);
      }
  }
  Gn(e, h, o) {
    if (this.qt.hu(e))
      return (
        r.info(`Custom Attribute "${e}" is blocklisted, ignoring.`), new s()
      );
    let n, u;
    return (
      null === h && null === o
        ? ((n = i.Gu), (u = { key: e }))
        : ((n = i.Xu), (u = { key: e, latitude: h, longitude: o })),
      t.q(n, u)
    );
  }
  Hn(s, e) {
    const h = { group_id: s, status: e };
    return t.q(i.Hu, h);
  }
}
